const getInitialState = () => ({
  user: null,
  token: null
});

export default getInitialState;
